let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("keJjk")).then(() => parcelRequire('cNsik'));